import {
  collection,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
} from 'firebase/firestore';
import { db } from '@festpix/services';

export type UserRole = 'admin' | 'vendor' | 'attendee';

export interface User {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  walletId?: string;
  createdAt?: any;
}

export async function getAllUsers(): Promise<User[]> {
  const usersQuery = query(collection(db, 'users'), orderBy('createdAt', 'desc'));
  const snapshot = await getDocs(usersQuery);

  const users: User[] = [];
  snapshot.forEach((doc) => {
    users.push({
      id: doc.id,
      ...doc.data(),
    } as User);
  });

  return users;
}

export async function updateUserRole(userId: string, role: UserRole): Promise<void> {
  await updateDoc(doc(db, 'users', userId), { role });
}

export async function deleteUser(userId: string): Promise<void> {
  await deleteDoc(doc(db, 'users', userId));
}
